import Swiper from "swiper";
import { Autoplay, Mousewheel, Navigation, Pagination, Parallax } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    const pauseBtn = document.querySelector("#swiper-pause-button");
    const swiperEl = document.querySelector(".swiper");
    let isManuallyPaused = false;

    if (!swiperEl) return;

    const updateA11y = (s) => {
        if (!s || !s.slides) return;
        s.slides.forEach((slide) => {
            const isVisible =
                slide.classList.contains("swiper-slide-active") || slide.classList.contains("swiper-slide-visible");
            slide.inert = !isVisible;
            slide.setAttribute("aria-hidden", String(!isVisible));
        });
    };

    const updatePauseButtonUI = (isPaused) => {
        if (!pauseBtn) return;
        pauseBtn.setAttribute("aria-label", isPaused ? "Play slideshow" : "Pause slideshow");
    };

    const swiper = new Swiper(".swiper", {
        modules: [Pagination, Mousewheel, Navigation, Autoplay, Parallax],
        loop: true,
        parallax: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: { el: ".swiper-pagination", clickable: true },
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        on: {
            init: (s) => updateA11y(s),
            slideChange: (s) => updateA11y(s),
            slideChangeTransitionEnd: (s) => updateA11y(s),
            autoplayResume: (s) => {
                if (isManuallyPaused) s.autoplay.stop();
            },
        },
    });

    pauseBtn?.addEventListener("click", () => {
        if (swiper.autoplay.running) {
            swiper.autoplay.stop();
            isManuallyPaused = true;
            updatePauseButtonUI(true);
        } else {
            swiper.autoplay.start();
            isManuallyPaused = false;
            updatePauseButtonUI(false);
        }
    });

    swiperEl.addEventListener("focusin", (e) => {
        if (e.target === pauseBtn) return;
        swiper.autoplay.stop();
        updatePauseButtonUI(true);
    });

    swiperEl.addEventListener("focusout", (e) => {
        if (!swiperEl.contains(e.relatedTarget) && !isManuallyPaused) {
            swiper.autoplay.start();
            updatePauseButtonUI(false);
        }
    });

    swiperEl.setAttribute("tabindex", "-1");
    swiperEl.addEventListener(
        "focus",
        () => {
            swiper.autoplay.stop();
            updatePauseButtonUI(true);
        },
        true,
    );
});
